// Styles
import './CustomArrow.scss';

// Libs
import React, { useMemo } from 'react';

// Common
import CustomArrowCommon from '@/common/components/blocks/Slider/CustomArrow/CustomArrow';
// Constants
import { NEXT, PREV } from '@/common/constants';
// Assets
import { ReactComponent as PrevIcon } from '@/materiaux/assets/icons/chevron-left.svg';
import { ReactComponent as NextIcon } from '@/materiaux/assets/icons/chevron-right.svg';

// PropTypes
import {
  CustomArrowDefaultProps,
  CustomArrowPropTypes,
} from './CustomArrow.proptypes';

const CustomArrow = ({ className, type, ...props }) => {
  /**
   * Return icon by type
   * @type {component}
   */
  const getButtonIcon = useMemo(() => {
    switch (type) {
      case PREV:
        return <PrevIcon className="custom-arrow__icon" />;
      case NEXT:
      default:
        return <NextIcon className="custom-arrow__icon" />;
    }
  }, [type]);

  /**
   * Generate classNames
   * @type {string}
   */
  const classNames = useMemo(
    () => ['custom-arrow', className].filter((val) => val).join(' '),
    [className],
  );

  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <CustomArrowCommon {...props} className={classNames}>
      {getButtonIcon}
    </CustomArrowCommon>
  );
};

CustomArrow.defaultProps = {
  ...CustomArrowDefaultProps,
};

CustomArrow.propTypes = {
  ...CustomArrowPropTypes,
};

export default CustomArrow;
